"use client";

import { useSearchBox } from "react-instantsearch";
import { useAlgoliaPopularSearches } from "~/features/algolia/hooks";
import styles from "./PopularSearches.module.css";

export const PopularSearches = () => {
	const { query, refine } = useSearchBox();
	const { data: popularSearches, isLoading } = useAlgoliaPopularSearches({
		limit: 8,
	});

	if (query || isLoading || !popularSearches || popularSearches.length === 0) return null;

	return (
		<div className={styles.root}>
			{popularSearches?.map((search, i) => (
				<button
					key={i}
					onClick={() => {
						refine(search);
					}}
					className={styles.search}
				>
					{search.charAt(0).toUpperCase() + search.slice(1)}
				</button>
			))}
		</div>
	);
};
